/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Import_Choose_ColumnInputs */



/**
* | output |
* | --- |
* | "Choose a column…" |
*
* @param {Team_Manager_Import_Choose_ColumnInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_import_choose_column = /** @type {((inputs?: Team_Manager_Import_Choose_ColumnInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Import_Choose_ColumnInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Choisir une colonne…")
	if (locale === "de") return /** @type {LocalizedString} */ ("Spalte wählen…")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scegli una colonna…")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите столбец…")
	if (locale === "es") return /** @type {LocalizedString} */ ("Elige una columna…")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择一列…")
	if (locale === "ja") return /** @type {LocalizedString} */ ("列を選択…")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कॉलम चुनें…")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Escolha uma coluna…")
	return /** @type {LocalizedString} */ ("Choose a column…")
});